import { call, put, select, takeEvery } from "redux-saga/effects";

import * as apis from "../../../network/apis/companyPortalUsers";
import messages from "../../../assets/locale/messages";
import { readPortalEventsListMeta } from "../../../utils/companyPortal/portalEventsList";
import { showErrorMsg, showSuccessMsg, showWarningMsg } from "../../../utils/Helpers";
import * as actions from "./actions";
import * as types from "./types";

function* getLoyalApplicantsSaga({ payload }) {
  try {
    yield put(
      actions.getLoyalApplicantsResponse({
        list: [],
        meta: { currentPage: 1, count: 0, pages: 1 },
      }),
    );
    const response = yield call(apis.getLoyalApplicants, payload);
    const meta = readPortalEventsListMeta(response);
    yield put(
      actions.getLoyalApplicantsResponse({
        list: response?.data?.data ?? [],
        meta,
      }),
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* bulkRemoveLoyalApplicantsSaga({ payload }) {
  try {
    const response = yield call(apis.bulkRemoveLoyalApplicants, {
      user_ids: payload.userIds,
    });

    if (response?.status === 207) {
      yield showWarningMsg(response.data?.message);
    } else {
      const lang = yield select((state) => state.locale.lang);
      const copy = messages[lang]?.applicants?.loyalApplicants?.removeModal;
      const count = payload.userIds.length;
      const successMsg =
        count === 1
          ? copy?.successSingle
          : (copy?.successMultiple || "").replace("{count}", count);
      yield showSuccessMsg(successMsg, true);
    }

    yield put(actions.getLoyalApplicantsRequest(payload.listParams));
    payload.onSuccess?.();
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
    payload.onError?.(error);
  }
}

export default function* companyLoyalApplicantsSagas() {
  yield takeEvery(types.GET_LOYAL_APPLICANTS_REQUEST, getLoyalApplicantsSaga);
  yield takeEvery(
    types.BULK_REMOVE_LOYAL_APPLICANTS_REQUEST,
    bulkRemoveLoyalApplicantsSaga,
  );
}
